import AppHome from "./home/appHome";
import options from "../common/config";

require.ensure(
  [],
  (require) => {
    require(`./../../clients/${process.env.CLIENT}/scss/index_web.scss`);
  },
  "css"
);

if (options.app.homeRedirectionLink) {
  if (
    (window.location.pathname.includes("index_org.html") ||
      window.location.pathname.includes("prod_index.html")) == false
  ) {
    window.location.assign(options.app.homeRedirectionLink);
  }
}

const app = new AppHome();

if (process.env.NODE_ENV !== "production") {
  window.app = app;
}



// WEBPACK FOOTER //
// ./src/web/home.js